export default (that) => [
  {
    type: 'seq',
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
  },
  {
    title: that.$l('INDEX.form_label_editContainerNo') || '编辑柜号',
    field: 'editContainerNo',
    minWidth: 100,
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_containerContractNo') || '外运子单号',
    field: 'containerContractNo',
    width: 120,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_containerNo') || '集装箱号',
    field: 'containerNo',
    minWidth: 150,
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_sealNo') || '箱封号',
    field: 'sealNo',
    minWidth: 150,
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.form_containerWeight') || '集装箱皮重(KG)',
    field: 'containerWeight',
    minWidth: 150,
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
]
